import { categorySchema } from './category';
import { CATEGORY_LABELS } from './category-labels';

export const CATEGORY_OPTIONS = categorySchema.options.map((value) => ({
  value,
  label: CATEGORY_LABELS[value].label,
}));
